import {makeAutoObservable} from "mobx";
import {logEvent} from "../utils";
import {completeOnboardingRequest} from "../requests";

const DEFAULT_ID = -20;

export const INVISIBLE_ID = -1;



const ONBOARDING_STEPS = {
    1: {
        title: "Deep scan",
        description: "Detailed scan with text segmentation by sentences",
        arrowPlacement: 'top'
    },
    2: {
        title: "Get certificate",
        description: "Get detailed scan report",
        arrowPlacement: 'top'
    },
    3: {
        title: "Scan history",
        description: "Scroll down to see your scan history",
        arrowPlacement: 'top-start'
    },
    4: {
        title: "Britishize text",
        description: "Make your text looks natural for UK",
        arrowPlacement: 'right-start'
    },
    5: {
        title: "Statistics",
        description: "Track the usage of Scan and Britishizer",
        arrowPlacement: 'right-start'
    },
    6: {
        title: "API keys",
        description: "Manage API keys: create, delete, track analytics",
        arrowPlacement: 'right-start'
    }
};

export class OnboardingStore {

    currentStep = DEFAULT_ID

    constructor(root) {
        this.root = root;
        makeAutoObservable(this);
    }

    getCurrentStepInfo() {
        if (!this.currentStep) return null;
        return ONBOARDING_STEPS[this.currentStep] || null;
    }

    getTotalSteps() {
        return Object.keys(ONBOARDING_STEPS).length;
    }

    async incrementStep() {
        if (!this.currentStep) return;
        const stepNumber = this.currentStep;
        logEvent("onboarding__step_viewed", {step: stepNumber});
        this.setCurrentStep(stepNumber + 1);
        if (stepNumber + 1 === this.getTotalSteps()) {
            await this.completeOnboarding();
        }
    }

    startOnboarding() {
        const user = this.root.getUser()
        if (user?.onboarding_completed) {
            this.setCurrentStep(DEFAULT_ID);
            return;
        }
        if (typeof document !== "undefined") {
            const tippyArrows = document.querySelectorAll('.tippy-arrow');
            setInterval(() => {
                tippyArrows.forEach(el => {
                    el.className = el.className + ' onboarding-arrow';
                })
            }, 1000);
        }
        this.setCurrentStep(1);
    }

    completeOnboarding = async () => {
        try {
            await completeOnboardingRequest();
            await this.root.user.refresh();
        } catch (err) {
            this.root.setError('Failed to complete onboarding');
        }
    };

    setCurrentStep(step) {
        this.currentStep = step;
    }

    async skipOnboarding() {
        this.setCurrentStep(DEFAULT_ID);
        await this.completeOnboarding();
    }
}